<template>
  <div class="intro-container">
    <div class="spartan-intro">
      <h2>Spartan Builders</h2>
      <div class="cta-spartan">
        <router-link to="/spartan-intro" class="spartan-intro-link">
          <span class="cta-trigger">click</span>
          <span class="cta-description">construction services</span>
        </router-link>
      </div>
    </div>

    <div class="shield-intro">
      <h2>Shield Maintenance</h2>
      <div class="cta-shield">
        <router-link to="/shield-intro" class="shield-intro-link">
          <span class="cta-trigger">click</span>
          <span class="cta-description">facility upkeep</span>
        </router-link>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Intro",
  methods: {
    spartanReveal: function() {
      console.log("run animation");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/stylesheets/base/_variables.scss";

.intro-container {
  display: flex;

  @media screen and (max-width: $medium-bp) {
    flex-direction: column;
  }

  @media screen and (min-width: $medium-bp+0.1) {
    flex-direction: row;
  }

  @media screen and (min-width: $medium-bp+0.1) and (max-width: 1024px) and (min-height: 1025px) {
    flex-direction: column;
  }
}

.spartan-intro,
.shield-intro {
  position: relative;
  // top: -1.2em;
  // border: 1px solid red;

  @media screen and (max-width: $medium-bp) {
    width: 100vw;
    height: 50vh;
    padding: 0;
  }

  @media screen and (min-width: $medium-bp+0.1) {
    height: 100vh;
    width: 50vw;
  }

  @media screen and (min-width: $medium-bp+0.1) and (max-width: 1024px) and (min-height: 1025px) {
    width: 100vw;
    height: 50vh;
  }
}

[class^="cta-"] {
  span {
    display: block;
  }

  .cta-trigger {
    text-transform: uppercase;
    font-family: pragmatica-extended, sans-serif;
  }
}

[class$="-intro-link"] {
  transition: all 0.4s;
  &:link {
    text-decoration: none;
  }

  &:active {
    color: #aa6b2c;
  }

  &:focus {
    color: lighten(#aa6b2c, 30%);
  }

  &:hover {
    color: lighten(#aa6b2c, 30%);
  }
}

// CTA POSITIONING

.cta-spartan,
.cta-shield {
  // most nobile
  @media screen and (max-width: 414px) {
    top: 40%;
  }

  // intermediate mobile
  @media screen and (min-width: 415px) and (max-width: $small-bp) {
    top: 43%;
  }

  // phablets to most tablets
  @media screen and (min-width: $small-bp+0.1) and (max-width: $medium-bp) {
    top: 45%;
  }

  // ipad pro
  @media only screen and (min-device-width: 1024px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
    top: 55%;
    font-size: 1.4em;
  }

  // small monitors
  @media screen and (min-width: $medium-bp+0.1) and (max-width: $large-bp) {
    top: 45%;
  }

  // large monitors
  @media screen and (min-width: $large-bp+0.1) and (max-width: $xlarge-bp) {
    top: 45%;
    font-size: 1.4em;
  }

  // xlarge monitors
  @media screen and (min-width: $xlarge-bp+0.1) {
    top: 50%;
    font-size: 1.6em;
  }

}

// SPARTAN STYLES

.cta-spartan {
  // background: red;
  position: absolute;
  text-align: right;
  right: 43%;

  .spartan-intro-link {
    color: #fff;
  }
}

// SHIELD STYLES

.cta-shield {
  position: absolute;
  text-align: left;
  left: 45%;

  .shield-intro-link {
    color: #444;
  }

}
</style>
